import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_select = _resolveComponent("the-select")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large",
    title: "Смена отв. бухгалтера",
    loading: _ctx.loading,
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.onSubmit
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_select, {
        placeholder: "Выберите тариф",
        value: _ctx.state.shipmentTariffId,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.shipmentTariffId) = $event)),
        "is-invalid": _ctx.state_form$.shipmentTariffId.$error,
        "validation-errors": _ctx.state_form$.shipmentTariffId.$errors,
        loading: false,
        failed: false,
        options: _ctx.TARIFFS,
        searchable: false
      }, null, 8, ["value", "is-invalid", "validation-errors", "options"]),
      _createVNode(_component_the_select, {
        class: "mt-3",
        placeholder: "Выберите бухгалтера",
        value: _ctx.state.accountantId,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.accountantId) = $event)),
        "is-invalid": _ctx.state_form$.accountantId.$error,
        "validation-errors": _ctx.state_form$.accountantId.$errors,
        loading: _ctx.data_state.accountants.is_loading,
        options: _ctx.data_state.accountants.list,
        failed: _ctx.data_state.accountants.is_failed,
        "error-text": "При получении списка бухгалтеров произошла ошибка",
        "infinite-scroll": "",
        searchable: false,
        onRefresh: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadAccountants(_ctx.data_state.accountants.pagination.current_page))),
        onLoadmore: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadMoreAccountants(_ctx.data_state.accountants.pagination.current_page + 1)))
      }, null, 8, ["value", "is-invalid", "validation-errors", "loading", "options", "failed"]),
      (_ctx.state.shipmentTariffId === 2)
        ? (_openBlock(), _createBlock(_component_the_select, {
            key: 0,
            class: "mt-2",
            placeholder: "Компания",
            loading: _ctx.data_state.companies.is_loading,
            failed: _ctx.data_state.companies.is_failed,
            "error-text": "При получении списка компаний произошла ошибка",
            options: _ctx.data_state.companies.list,
            value: _ctx.state.companyId,
            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.companyId) = $event)),
            "search-without-refresh": "",
            "is-invalid": _ctx.state_form$.companyId.$error,
            "validation-errors": _ctx.state_form$.companyId.$errors,
            onRefresh: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadCompanies(_ctx.data_state.companies.pagination.current_page)))
          }, null, 8, ["loading", "failed", "options", "value", "is-invalid", "validation-errors"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["loading", "onCancel", "onConfirm"]))
}